import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class PBIService {
  constructor(private dataService: DataService) {
  }
  url = environment.api_base_url;


  getPBIToken(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "auth/pbi/access-token").subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getPBIRefreshToken(data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "auth/pbi/refresh-token", data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  auditReport(data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "management/audit/save", data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

}